import logo from './logo.svg';
import { useState, useEffect } from 'react';
import './App.css';
import {
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import SiteCreation from './pages/siteCreation';
import {
  BackgroundAIJobProvider,
} from "./components/backgroundAIJobContext";
import Upload from './pages/upload';
import File from './pages/files';
import AccessManager from './pages/accessManager';
import Approval from './pages/approval';
import SurveyManagment from './pages/surveyManagment';
import CourtCases from './pages/litigation';
import { lightTheme } from './components/common/Theme';
import { ThemeProvider } from 'styled-components';
import { useCookies } from "react-cookie";
import DisplayMessage from './pages/message';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import Login from './pages/login';
import DashBoards from './pages/Dashboard';
import Building from './pages/building';
import { FilterProvider } from './context/filterContext';

// Role-aware ProtectedRoute
const ProtectedRoute = ({ children, allowedRoles }) => {
  const [cookies] = useCookies(['permissions']);
  const userRole = cookies.permissions;

  if (!userRole) {
    // Not authenticated, redirect to login
    return <Navigate to="/" replace />;
  }
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    // Not authorized, redirect to /file (or another safe page)
    return <Navigate to="/file" replace />;
  }
  return children;
};

function App() {
  const [theme] = useState(lightTheme);
  const { instance, accounts } = useMsal();

  useEffect(() => {
    if (accounts.length > 0) {
      instance.setActiveAccount(accounts[0]);
    }
  }, [accounts, instance]);

  // Handle redirect response
  useEffect(() => {
    const handleRedirectResponse = async () => {
      try {
        const response = await instance.handleRedirectPromise();
        if (response) {
          console.log('Redirect response received:', response);
        }
      } catch (error) {
        console.error('Error handling redirect response:', error);
      }
    };
    handleRedirectResponse();
  }, [instance]);

 return (
  <>
    <ThemeProvider theme={theme}>
  <FilterProvider>
    <BackgroundAIJobProvider>
      <Routes>
          <Route path="/" element={<Login />} />

          {/* Site Creation */}
          <Route
            path="/sitecreation"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "Admin",
                  "Location Admin",
                  "State Admin",
                ]}
              >
                <SiteCreation />
              </ProtectedRoute>
            }
          />

          {/* Survey Management */}
          <Route
            path="/survey-managment"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "Admin",
                  "Location Admin",
                  "State Admin",
                ]}
              >
                <SurveyManagment />
              </ProtectedRoute>
            }
          />

          {/* Court Litigation */}
          <Route
            path="/court-litigation"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "Admin",
                  "Location Admin",
                  "State Admin",
                ]}
              >
                <CourtCases />
              </ProtectedRoute>
            }
          />

          {/* Upload */}
          <Route
            path="/upload"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "Admin",
                  "Spoc",
                  "Location Admin",
                  "State Admin",
                ]}
              >
                <Upload />
              </ProtectedRoute>
            }
          />

          {/* File */}
          <Route
            path="/file"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "Admin",
                  "Spoc",
                  "End User",
                  "Location Admin",
                  "State Admin",
                ]}
              >
                <File />
              </ProtectedRoute>
            }
          />

          {/* Access Manager */}
          <Route
            path="/access-manager"
            element={
              <ProtectedRoute allowedRoles={["Admin"]}>
                <AccessManager />
              </ProtectedRoute>
            }
          />

          {/* Approval */}
          <Route
            path="/approval"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "Admin",
                  "Location Admin",
                  "State Admin",
                ]}
              >
                <Approval />
              </ProtectedRoute>
            }
          />

          {/* Reports */}
          <Route
            path="/report"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "Admin",
                  "End User",
                  "Spoc",
                  "Location Admin",
                  "State Admin",
                ]}
              >
                <DashBoards />
              </ProtectedRoute>
            }
          />

          {/* Building */}
          <Route
            path="/building"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "Admin",
                  "Location Admin",
                  "State Admin",
                ]}
              >
                <Building />
              </ProtectedRoute>
            }
          />

          {/* Dashboard */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "Admin",
                  "Spoc",
                  "End User",
                  "Location Admin",
                  "State Admin",
                ]}
              >
                <DashBoards />
              </ProtectedRoute>
            }
          />

          <Route path="/message" element={<DisplayMessage />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>   </BackgroundAIJobProvider>
      </FilterProvider>
    </ThemeProvider>
  </>
);
}

export default App;
